<perfect-scrollbar style="max-width: 500px; max-height: 130px;">
	<div (clickOutside)="close()" class="flex-table">
		<div class="flex-row">
			<div class="flex-cell" octRtlView>{{data}}</div>
		</div>
	</div>
</perfect-scrollbar>
